import { POST_PAYMENT_ABSTRACT_FORM_STEP } from "../registration/registrationModules";

export const currentHost = window.location.host;
export const TOTAL_STEPS = POST_PAYMENT_ABSTRACT_FORM_STEP;
export const MOBILE_MAX_LENGTH = 10;

export const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY;
export const REGISTRATION_BASE_URL =
  process.env.REACT_APP_REGISTRATION_API_URL || "http://localhost:8085";
export const PAYMENT_BASE_URL =
  process.env.REACT_APP_PAYMENT_API_URL || "http://localhost:8085";
export const CONFERENCE_API =
  process.env.REACT_APP_CONFERENCE_API_URL ||
  "http://localhost:8080/conference";

export const CONFERENCE_REGISTRATION_URL = `${REGISTRATION_BASE_URL}/registration`;
export const ORDER_URL = `${PAYMENT_BASE_URL}/payment/create-order`;
export const PAYMENT_SAVE_URL = `${PAYMENT_BASE_URL}/payment/save-with-breakdown`;

export const logRegistrationEnvironment = () => {
  console.log("🔧 Environment Variables:");
  console.log("  REGISTRATION_BASE_URL:", REGISTRATION_BASE_URL);
  console.log("  PAYMENT_BASE_URL:", PAYMENT_BASE_URL);
  console.log("  CONFERENCE_API:", CONFERENCE_API);
};
